import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1ed4ba9c&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=1ed4ba9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4ba9c",
  null
  
)

export default component.exports